import {
  BudgetValidationCards,
  BudgetValidationDecisionPayload,
  BudgetValidationQueueRow,
} from './types';

const postBiz = async (payload: any) => {
  const res = await fetch('/biz', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });

  const json = await res.json();

  if (!res.ok || json.failure) {
    throw new Error(json.em || json.message || 'Request failed');
  }

  return json;
};

const unwrap = (json: any) => json?.result || json?.data || json;

const rows = (json: any) => {
  const x = unwrap(json);
  const sd = x?.sd || json?.sd || json?.data?.sd || json?.result?.sd;
  return Array.isArray(sd) ? sd : [];
};

const objectResult = (json: any) => {
  const x = unwrap(json);
  return x?.sd?.[0] || x?.sd || x || {};
};

export const generateBudgetValidationSession = async (
  scenarioCode: string,
  pressureId: number | null,
  name: string
) => {
  return objectResult(await postBiz({
    s: 'budgetvalidation',
    a: 'generate',
    scc: scenarioCode,
    bpi: pressureId,
    nam: name || null,
  }));
};

export const runBudgetValidationRecommendations = async (sessionId: number) => {
  return objectResult(await postBiz({
    s: 'budgetvalidation',
    a: 'recommend',
    rid: sessionId,
  }));
};

export const fetchBudgetValidationCards = async (
  sessionId: number
): Promise<BudgetValidationCards> => {
  return objectResult(await postBiz({
    s: 'budgetvalidation',
    a: 'cards',
    rid: sessionId,
  }));
};

export const fetchBudgetValidationQueue = async (
  sessionId: number,
  sourceCode = '',
  decisionCode = ''
): Promise<BudgetValidationQueueRow[]> => {
  return rows(await postBiz({
    s: 'budgetvalidation',
    a: 'queue',
    rid: sessionId,
    src: sourceCode || null,
    dcc: decisionCode || null,
  }));
};

export const decideBudgetValidationItem = async (
  payload: BudgetValidationDecisionPayload
) => {
  return objectResult(await postBiz({
    s: 'budgetvalidation',
    a: 'decide',
    rid: payload.rid,
    dcc: payload.dcc,
    amt: payload.amt,
    dcr: payload.dcr,
  }));
};

// Add these to budgetValidationApi.ts when middleware supports them.

export const fetchBudgetValidationScenarios = async () =>
  //rows(await postBiz({ s: 'budgetvalidation', a: 'scenarios' }));
  rows(await postBiz({ s: 'budgetvalidation', a: 'scenarios' }));

export const fetchBudgetValidationSessions = async () =>
  //rows(await postBiz({ s: 'budgetvalidation', a: 'sessions' }));
  rows(await postBiz({ s: 'budgetvalidationsession', a: 'find' }));

export const fetchBudgetValidationSources = async () =>
  //rows(await postBiz({ s: 'budgetvalidation', a: 'sources' }));
  rows(await postBiz({ s: 'budgetvalidation', a: 'sources' }));

export const fetchBudgetValidationDecisions = async () =>
  //rows(await postBiz({ s: 'budgetvalidation', a: 'decisions' }));
  rows(await postBiz({ s: 'budgetvalidation', a: 'sources' }));

export const defaultBudgetSources = [
  { shc: 'ACTIVITY', nam: 'Activity Budget' },
  { shc: 'DIRECT', nam: 'Direct Budget' },
  { shc: 'INVESTMENT', nam: 'Investment Budget' },
];

export const defaultBudgetDecisions = [
  { shc: 'PENDING', nam: 'Pending' },
  { shc: 'APPROVED', nam: 'Approved' },
  { shc: 'REDUCED', nam: 'Reduced' },
  { shc: 'REJECTED', nam: 'Rejected' },
  { shc: 'HOLD', nam: 'Hold' },
  { shc: 'ESCALATED', nam: 'Escalated' },
];
